// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2UXRb","content":"RecentSearches_content__1Y52g"};